import React, { useState } from "react";
import { LuHardDrive } from "react-icons/lu";
import { FaUsers } from "react-icons/fa";

import Chatlogs from "../Activity/Chatlogs";
import Leads from "../Activity/Leads";
import { Menus } from "../../../../components/Menus";

const options = [
  {
    key: "chatlogs",
    label: "Chat Logs",
    icon: <LuHardDrive size={24} />,
  },
  {
    key: "leads",
    label: "Leads",
    icon: <FaUsers size={24} />,
  },
];

const Activity = ({ userId, botId }) => {
  const [activeOption, setActiveOption] = useState("chatlogs");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  return (
    <div className="flex flex-1 gap-4 flex-col relative p-6 py-4">
      <h1 className="text-2xl font-semibold text-gray-600 my-3">Activity</h1>
      <div className="flex gap-3 sm:gap-5 md:gap-10 flex-col md:flex-row">
        <Menus
          options={options}
          setActiveOption={setActiveOption}
          activeOption={activeOption}
        />
        {/* Optional: render content based on activeOption */}
        <div className="flex-1 ">
          {activeOption === "chatlogs" && (
            <Chatlogs
              userId={userId}
              botId={botId}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          )}
          {activeOption === "leads" && <Leads userId={userId} botId={botId} />}
        </div>
      </div>
    </div>
  );
};

export default Activity;
